import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Users, Settings as Cog, ShieldCheck, Boxes, DollarSign, LogOut } from 'lucide-react';

export default function Settings() {
  const { user, logout } = useAuth();
  const cards = [
    { to: '/employees', label: 'Usuários e permissões', icon: Users, desc: 'Cadastrar funcionários, definir comissões e permissões', adminOnly: true },
    { to: '/stock', label: 'Estoque mínimo', icon: Boxes, desc: 'Configurar estoque mínimo por produto na página Produtos' },
    { to: '/finance', label: 'Financeiro', icon: DollarSign, desc: 'Registrar despesas manuais e ver resultado do mês' },
    { to: '/audit', label: 'Auditoria', icon: ShieldCheck, desc: 'Histórico completo de operações do sistema' },
  ].filter((c) => !c.adminOnly || user?.role === 'admin');

  return (
    <div className="p-4 h-full overflow-y-auto space-y-4">
      <h2 className="text-xl font-black flex items-center gap-2"><Cog/> Configurações</h2>

      <div className="bg-white rounded-2xl border border-slate-200 p-4 space-y-1" data-testid="settings-account">
        <div className="text-[11px] text-slate-500 font-semibold uppercase">Conta atual</div>
        <div className="font-bold">{user?.name}</div>
        <div className="text-xs text-slate-500">@{user?.username} · {user?.role === 'admin' ? 'Administrador' : 'Funcionário'}</div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-4 space-y-1">
        <div className="text-[11px] text-slate-500 font-semibold uppercase">Formas de pagamento</div>
        <div className="text-sm">Dinheiro · Pix · Débito · Crédito (configurado)</div>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {cards.map((c) => (
          <NavLink key={c.to} to={c.to} data-testid={`settings-${c.to.slice(1)}`}
                   className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center gap-3 active:scale-[0.98]">
            <div className="w-10 h-10 rounded-xl bg-orange-50 text-orange-600 grid place-items-center"><c.icon size={20}/></div>
            <div className="flex-1">
              <div className="font-bold text-sm">{c.label}</div>
              <div className="text-xs text-slate-500">{c.desc}</div>
            </div>
          </NavLink>
        ))}
      </div>

      <button onClick={logout} data-testid="settings-logout"
              className="w-full h-12 rounded-xl bg-red-50 text-red-600 font-bold flex items-center justify-center gap-2 active:scale-[0.98]">
        <LogOut size={18}/> Sair
      </button>
    </div>
  );
}
